import { modalsKey } from '@gat-ship/vue-components'
import { h, inject, type Component } from 'vue'
import { type ShowCreateSupportSessionDialogParams } from './modal-create-support-session.vue'
import { type ShowEndSupportSessionDialogParams } from './modal-end-support-session.vue'
import { type ShowSupportSessionDetailsDialogParams } from './modal-support-session-details.vue'

export { default as ModalCreateSupportSession } from './modal-create-support-session.vue'
export { default as ModalEndSupportSession } from './modal-end-support-session.vue'
export { default as ModalSupportSessionDetails } from './modal-support-session-details.vue'
export * from './modal-create-support-session.vue'
export * from './modal-end-support-session.vue'
export * from './modal-support-session-details.vue'

export type SupportDialog =
  | 'new-support-session'
  | 'end-support-session'
  | 'support-session-details'

export type SupportModalParams<T extends SupportDialog> = {
  'new-support-session': ShowCreateSupportSessionDialogParams
  'end-support-session': ShowEndSupportSessionDialogParams
  'support-session-details': ShowSupportSessionDetailsDialogParams
}[T]

export function useSupportModal<T extends SupportDialog>(modalName: T) {
  async function getComponentInstance(): Promise<Component> {
    if (modalName === 'new-support-session') {
      return (await import('./modal-create-support-session.vue'))['default']
    }
    if (modalName === 'end-support-session') {
      return (await import('./modal-end-support-session.vue'))['default']
    }
    if (modalName === 'support-session-details') {
      return (await import('./modal-support-session-details.vue'))['default']
    }
    throw new Error(`Modal ${modalName} not found`)
  }

  const appModal = inject(modalsKey)

  async function showModal(params: SupportModalParams<T>) {
    if (!appModal) {
      console.warn('Failed to inject modalsKey')
      return
    }
    const component = await getComponentInstance()
    appModal.mountComponent(component)
    const instance = await appModal.getInstance()
    if (instance?.value && 'showModal' in instance.value) {
      instance.value.showModal(params)
    }
  }

  return {
    showModal
  }
}
